import React, { useMemo } from 'react';
import { Select } from 'antd';
import {
  REFERENCE_ANNOTATION_GROUPS,
  REFERENCE_ANNOTATION_GROUP_LABELS,
  DIMENSIONAL_OUTPUT_GROUPS,
  DIMENSIONAL_OUTPUT_GROUP_LABELS,
  ALL_MAPPING_KINDS,
  TAXONOMY_STATS,
} from '../../constants/drawingTaxonomy';

function buildGroupedKindOptions() {
  const reference = Object.entries(REFERENCE_ANNOTATION_GROUPS).map(([key, kinds]) => ({
    label: `Reference — ${REFERENCE_ANNOTATION_GROUP_LABELS[key] || key}`,
    options: kinds.map((k) => ({ value: k, label: k })),
  }));
  const dimensional = Object.entries(DIMENSIONAL_OUTPUT_GROUPS).map(([key, kinds]) => ({
    label: `Dimensional — ${DIMENSIONAL_OUTPUT_GROUP_LABELS[key] || key}`,
    options: kinds.map((k) => ({ value: k, label: k })),
  }));
  const grouped = [...reference, ...dimensional];

  const uniqueInSelect = new Set();
  for (const group of grouped) {
    for (const opt of group.options) uniqueInSelect.add(opt.value);
  }
  if (uniqueInSelect.size !== ALL_MAPPING_KINDS.length) {
    const missing = ALL_MAPPING_KINDS.filter((k) => !uniqueInSelect.has(k));
    throw new Error(
      `KindSearchSelect taxonomy incomplete: ${uniqueInSelect.size}/${ALL_MAPPING_KINDS.length} kinds. `
      + `Missing: ${missing.slice(0, 8).join(', ')}`
    );
  }

  return grouped;
}

const GROUPED_KIND_OPTIONS = buildGroupedKindOptions();
export { TAXONOMY_STATS };

export default function KindSearchSelect({
  value,
  onChange,
  placeholder = 'Search label type…',
  style,
  disabled,
  autoFocus = false,
  dropdownOpen,
  onDropdownOpenChange,
}) {
  const options = useMemo(() => GROUPED_KIND_OPTIONS, []);

  return (
    <Select
      showSearch
      allowClear
      disabled={disabled}
      autoFocus={autoFocus}
      open={dropdownOpen}
      onOpenChange={onDropdownOpenChange}
      optionFilterProp="label"
      filterOption={(input, option) => {
        const label = option?.label ?? '';
        return String(label).toLowerCase().includes(input.trim().toLowerCase());
      }}
      style={{ flex: 1, minWidth: 240, ...style }}
      value={value || undefined}
      onChange={(v) => onChange(v ?? '')}
      placeholder={placeholder}
      options={options}
      listHeight={380}
      popupMatchSelectWidth={420}
      notFoundContent="No matching label types"
    />
  );
}
